import { RouteObject } from "react-router-dom";
import History from "./components/History";
import ScheduledNotificationDetails from "./components/detail/detail";

export interface uxHistoryRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: uxHistoryRoute[];
}

export const uxHistoryRoutes: uxHistoryRoute[] = [
  {
    path: "communication-hub/history",
    element: <History />,
  },
  {
    path: "communication-hub/scheduled/:notificationId",
    element: <ScheduledNotificationDetails />,
  },
];
